import { IconChevronLeft } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { popSettingsView } from "../../../domains/app/stores/settingsSheetStore";

export function SettingsSubHeader({
  title,
}: {
  title: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    // Figma O4 (4775:1303): 16px between the back button and the title, and
    // between the title and the content.
    <div className="shrink-0 px-5 pb-4">
      <button
        type="button"
        onClick={popSettingsView}
        aria-label={t("Back")}
        className="flex size-6 items-center justify-center text-ds-black"
      >
        <IconChevronLeft size={24} stroke={2} />
      </button>
      <h2 className="m-0 mt-4 text-heading-display font-semibold text-ds-black">
        {title}
      </h2>
    </div>
  );
}
